module.exports = __webpack_public_path__ + "static/22_tat3-2-e1eb5d28f1954c55d05ad5c11325b56d.jpg";